import { cn } from "@utils/cn.ts";
import { useRosterFocusStore } from "@/store/rosterFocusStore";

function ThCalendarDay({
  day,
  holiday,
  weekDay,
  prefix,
  /** false: 열 클릭 시 선택 하이라이트 없음(호버만) — 원티드 관리보드 설정 등 */
  selectionFocusOnClick = true,
}: {
  day: number;
  isEveryFifth?: boolean;
  holiday: string;
  weekDay?: string;
  prefix?: string;
  selectionFocusOnClick?: boolean;
}) {
  const columnKey = prefix ? `${prefix}day${day}` : `day${day}`;

  const isColumnHovered = useRosterFocusStore(
    (s) => s.hoveredColumn === columnKey
  );
  const isColumnSelected = useRosterFocusStore(
    (s) => s.selectedColumn === columnKey
  );

  const setHoveredFocus = useRosterFocusStore((s) => s.setHoveredFocus);
  const clearHoveredFocus = useRosterFocusStore((s) => s.clearHoveredFocus);
  const setSelectedFocus = useRosterFocusStore((s) => s.setSelectedFocus);
  const clearSelectedFocus = useRosterFocusStore((s) => s.clearSelectedFocus);
  const selectedColumn = useRosterFocusStore((s) => s.selectedColumn);
  const selectedNurseId = useRosterFocusStore((s) => s.selectedNurseId);

  const highlightBg =
    selectionFocusOnClick && isColumnSelected
      ? "rgba(169, 223, 254, 0.4)"
      : isColumnHovered
        ? "rgba(169, 223, 254, 0.3)"
        : undefined;

  const holidayTextClass = () => {
    switch (holiday) {
      case "sun":
        return "text-[#ff88cc]";
      case "sat":
        return "text-[#72bfff]";
      case "holiday":
        return "text-[#ed1c24]";
      default:
        return "text-[#939399]";
    }
  };

  return (
    <div
      data-roster-header-day=""
      data-column={columnKey}
      style={highlightBg != null ? { backgroundColor: highlightBg } : undefined}
      className="flex items-center rounded-t-sm pt-1"
    >
      <div
        className={cn(
          "flex flex-col h-full text-sm font-pretendard text-muted-foreground text-center justify-center items-center !leading-none size-[34px]",
          holidayTextClass()
        )}
        onMouseEnter={() => {
          setHoveredFocus({ column: columnKey, nurseId: "" });
        }}
        onMouseLeave={() => {
          clearHoveredFocus();
        }}
        onClick={(e) => {
          e.stopPropagation();
          if (selectionFocusOnClick) {
            if (selectedColumn === columnKey && selectedNurseId === "") {
              clearSelectedFocus();
            } else {
              setSelectedFocus({ column: columnKey, nurseId: "" });
            }
          }
        }}
      >
        {weekDay && <span className="text-[12px] leading-none">{weekDay}</span>}
        {day}
      </div>
    </div>
  );
}

export default ThCalendarDay;
